export default function Budget() {
  const budgetData = [
    {
      category: 'التخطيط والإدارة',
      items: [
        { name: 'مدير مشروع', quantity: 1, unitCost: 12000, total: 12000 },
        { name: 'منسق عام', quantity: 1, unitCost: 8000, total: 8000 },
        { name: 'فريق العمل', quantity: 6, unitCost: 4000, total: 24000 },
        { name: 'منصة الكترونية للملتقى', quantity: 1, unitCost: 15000, total: 15000 }
      ]
    },
    {
      category: 'المحتوى العلمي',
      items: [
        { name: 'مكافآت أوراق العمل', quantity: 6, unitCost: 4000, total: 24000 },
        { name: 'تذاكر وفنادق مقدمي أوراق العمل', quantity: 6, unitCost: 2500, total: 15000 },
        { name: 'مدربو ورش العمل', quantity: 4, unitCost: 5000, total: 20000 },
        { name: 'تذاكر وفنادق مدربي ورش العمل', quantity: 4, unitCost: 2500, total: 10000 }
      ]
    },
    {
      category: 'التنظيم واللوجستيات',
      items: [
        { name: 'قاعة الملتقى (يومان)', quantity: 1, unitCost: 25000, total: 25000 },
        { name: 'تجهيزات تقنية وصوتية', quantity: 1, unitCost: 10000, total: 10000 },
        { name: 'ضيافة المشاركين', quantity: 200, unitCost: 80, total: 16000 },
        { name: 'ضيافة الجمعيات الشبابية المشاركة من مختلف مناطق المملكة', quantity: 30, unitCost: 8000, total: 240000 },
        { name: 'ضيافة الجهات المانحة', quantity: 10, unitCost: 8000, total: 80000 }
      ]
    },
    {
      category: 'المعرض المصاحب',
      items: [
        { name: 'تجهيز أجنحة المعرض', quantity: 10, unitCost: 2500, total: 25000 }
      ]
    },
    {
      category: 'الإعلام والتسويق',
      items: [
        { name: 'حملة إعلامية', quantity: 1, unitCost: 20000, total: 20000 },
        { name: 'مطبوعات', quantity: 1, unitCost: 12000, total: 12000 },
        { name: 'تصوير وتغطية', quantity: 1, unitCost: 25000, total: 25000 }
      ]
    },
    {
      category: 'المتطوعون',
      items: [
        { name: 'مكافآت وتحفيز', quantity: 20, unitCost: 300, total: 6000 }
      ]
    },
    {
      category: 'حفل الختام',
      items: [
        { name: 'تنظيم الحفل', quantity: 1, unitCost: 10000, total: 10000 },
        { name: 'تكريم', quantity: 15, unitCost: 1000, total: 15000 },
        { name: 'هدايا تذكارية', quantity: 200, unitCost: 30, total: 6000 }
      ]
    },
    {
      category: 'تقارير ومخرجات',
      items: [
        { name: 'تصميم وطباعة التقرير', quantity: 1, unitCost: 10000, total: 10000 }
      ]
    }
  ];

  const formatNumber = (num: number) => {
    return num.toLocaleString('en-US');
  };

  const calculateCategoryTotal = (items: typeof budgetData[0]['items']) => {
    return items.reduce((sum, item) => sum + item.total, 0);
  };

  const grandTotal = budgetData.reduce((sum, category) => 
    sum + calculateCategoryTotal(category.items), 0
  );

  return (
    <section id="budget" className="py-10 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block mb-3 md:mb-4">
            <div className="flex items-center gap-2 md:gap-3 bg-[#F5F5DC] px-4 md:px-6 py-2 md:py-3 rounded-full">
              <i className="ri-money-dollar-circle-line text-xl md:text-2xl text-[#D4AF37]"></i>
              <span className="text-xs md:text-sm font-bold text-[#1B5E20] tracking-wider">الموازنة التقديرية</span>
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B5E20] mb-4 md:mb-6 px-4">
            الموازنة التفصيلية للملتقى
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            تفاصيل شاملة للتكاليف المقدرة لتنظيم ملتقى احتياجات الشباب بأعلى معايير الجودة والاحترافية
          </p>
        </div>

        <div className="space-y-6 md:space-y-8">
          {budgetData.map((category, idx) => (
            <div 
              key={idx}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl md:rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300"
            >
              <div className="bg-gradient-to-l from-[#1B5E20] to-[#2E7D32] px-4 md:px-8 py-4 md:py-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="text-lg md:text-2xl font-bold text-white flex items-center gap-2 md:gap-3">
                    <i className="ri-folder-line text-[#D4AF37] text-base md:text-xl"></i>
                    <span className="leading-tight">{category.category}</span>
                  </h3>
                  <div className="bg-white/20 backdrop-blur-sm px-3 md:px-6 py-1.5 md:py-2 rounded-full">
                    <span className="text-white font-bold text-sm md:text-lg whitespace-nowrap">
                      {formatNumber(calculateCategoryTotal(category.items))} ريال
                    </span>
                  </div>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-100 border-b border-gray-200">
                      <th className="px-3 md:px-8 py-3 md:py-4 text-right text-xs md:text-sm font-bold text-gray-700">النشاط</th>
                      <th className="px-2 md:px-6 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-gray-700">العدد</th>
                      <th className="px-2 md:px-6 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-gray-700 whitespace-nowrap">التكلفة للوحدة</th>
                      <th className="px-3 md:px-8 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-gray-700">الإجمالي</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.items.map((item, itemIdx) => (
                      <tr 
                        key={itemIdx}
                        className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                      >
                        <td className="px-3 md:px-8 py-3 md:py-5 text-gray-800 text-xs md:text-base">{item.name}</td>
                        <td className="px-2 md:px-6 py-3 md:py-5 text-center text-gray-700 font-medium text-xs md:text-base">{formatNumber(item.quantity)}</td>
                        <td className="px-2 md:px-6 py-3 md:py-5 text-center text-gray-700 font-medium text-xs md:text-base whitespace-nowrap">{formatNumber(item.unitCost)}</td>
                        <td className="px-3 md:px-8 py-3 md:py-5 text-center">
                          <span className="inline-block bg-[#F5F5DC] px-2 md:px-4 py-1 md:py-2 rounded-lg font-bold text-[#1B5E20] text-xs md:text-base whitespace-nowrap">
                            {formatNumber(item.total)} ريال
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-2xl md:rounded-3xl shadow-2xl p-6 md:p-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
            <div className="text-center md:text-right">
              <div className="flex items-center justify-center md:justify-start gap-3 md:gap-4 mb-2 md:mb-3">
                <i className="ri-calculator-line text-3xl md:text-5xl text-[#D4AF37]"></i>
                <h3 className="text-2xl md:text-3xl font-bold text-white">الإجمالي الكلي للموازنة</h3>
              </div>
              <p className="text-white/80 text-sm md:text-lg">التكلفة الإجمالية المقدرة لتنظيم الملتقى</p>
            </div>
            <div className="bg-white rounded-xl md:rounded-2xl px-8 md:px-12 py-6 md:py-8 shadow-xl">
              <div className="text-center">
                <div className="text-4xl md:text-6xl font-bold text-[#1B5E20] mb-2">
                  {formatNumber(grandTotal)}
                </div>
                <div className="text-lg md:text-2xl font-bold text-[#D4AF37]">ريال سعودي</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="bg-gradient-to-br from-[#F5F5DC] to-white p-6 md:p-8 rounded-xl md:rounded-2xl shadow-lg border border-gray-100">
            <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-[#1B5E20] rounded-full flex items-center justify-center">
                <i className="ri-team-line text-xl md:text-2xl text-white"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1B5E20]">الموارد البشرية</h4>
            </div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              استثمار في الكفاءات والخبرات لضمان نجاح الملتقى وتحقيق أهدافه الاستراتيجية
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#F5F5DC] to-white p-6 md:p-8 rounded-xl md:rounded-2xl shadow-lg border border-gray-100">
            <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-[#1B5E20] rounded-full flex items-center justify-center">
                <i className="ri-building-line text-xl md:text-2xl text-white"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1B5E20]">البنية التحتية</h4>
            </div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              توفير أفضل المرافق والتجهيزات التقنية لتجربة احترافية ومميزة للمشاركين
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#F5F5DC] to-white p-6 md:p-8 rounded-xl md:rounded-2xl shadow-lg border border-gray-100">
            <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-[#1B5E20] rounded-full flex items-center justify-center">
                <i className="ri-megaphone-line text-xl md:text-2xl text-white"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1B5E20]">التسويق والإعلام</h4>
            </div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              حملة إعلامية شاملة لضمان وصول رسالة الملتقى وتحقيق أكبر تأثير ممكن
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
